import { createContext, useContext } from 'react'
import invariant from 'tiny-invariant'

import type { SelfAssessmentDefinition } from '@/src/domains/self-assessments/schemas'

import type { SelfAssessmentStep } from './SelfAssessmentWizard.constants'

export interface SelfAssessmentWizardContextValue {
  definition: SelfAssessmentDefinition
  step: SelfAssessmentStep
  questionIndex: number
  isLastQuestion: boolean
  hasNavigated: boolean
  handleStart: () => void
  handleBack: () => void
}

export const SelfAssessmentWizardContext = createContext<SelfAssessmentWizardContextValue | null>(null)

export const useSelfAssessmentWizard = () => {
  const context = useContext(SelfAssessmentWizardContext)

  invariant(context, 'useSelfAssessmentWizard must be used within SelfAssessmentWizard')

  return context
}
